import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { LinearProgress } from '@mui/material';
import EntitiesModal from './EntitiesModal';
import { getTargetName, getStatusColor } from './Row';

export default function ETLChangesRow({row, theme, date}) {
    const apiUrl = process.env.REACT_APP_API_URL;
    const [open, setOpen] = useState(false);
    const [etlChanges, setETLChanges] = useState({});
    const [loading, setLoading] = useState(false);

    const handleRowClick = async () => {
        setOpen(!open);
        if (!open) {
            try {
                setLoading(true);
                const response = await fetch(`${apiUrl}etl_changes?log_date=${date}`)
                const json = await response.json();
                const entityList = json.entityList
                const metadataCount = json.metadataCount
                const rpaEntities = json.rpaEntities
                const readyEntities = json.readyEntities
                const mostCommonChange = json.mostCommonChange
                const etlChanges = {
                    "entityList": entityList, 
                    "metadataCount": metadataCount, 
                    "rpaEntities": rpaEntities, 
                    "readyEntities": readyEntities, 
                    "mostCommonChange": mostCommonChange
                }
                setLoading(false);
                setETLChanges(etlChanges);
            } catch (error) {
                alert(`Error ${error} has occurred while trying to fetch today's ETL changes.`)
                setLoading(false);
                setOpen(false);
            }
        }
    };
    
    return (
        <React.Fragment>
            <TableRow sx={{'& > *': {borderBottom: 'unset'}}}>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={handleRowClick}>
                        {open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">
                    {row.syncBatchId}
                </TableCell>
                <TableCell align="right">{row.login}</TableCell>
                <TableCell align="right">{getTargetName(row.syncTarget)}</TableCell>
                <TableCell align="right">{row.syncType === "METADATA" ? "EXTERNAL DATA" : row.syncType}</TableCell>
                <TableCell align="right">{row.syncEntityCount}</TableCell>
                <TableCell align="right">{row.syncMetadataCount}</TableCell>
                <TableCell align="right">{row.syncStart?.substring(0, 10)} {row.syncStart?.substring(11)}</TableCell>
                <TableCell align="right">{row.syncFinishTime?.substring(0, 10)} {row.syncFinishTime?.substring(11)}</TableCell>
                <TableCell align="right" style={{color: `${getStatusColor(row.syncStatus)}`}}>{row.syncStatus}</TableCell>
            </TableRow>
            {loading ? <LinearProgress sx={{ position: 'absolute', width: '100%' }}/> : Object.keys(etlChanges) !== 0 && (
                <TableRow>
                    <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={10}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box sx={{margin: 1}}>
                                <Typography variant="h6" gutterBottom component="div">
                                    {date} ETL Changes
                                </Typography>
                                <Table size="small" aria-label="jobs">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                Ready entities
                                            </TableCell>
                                            <TableCell>
                                                RPA Entities
                                            </TableCell>
                                            <TableCell>
                                                Most common change
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow key={etlChanges.entityList?.length}>
                                            <TableCell>
                                                <EntitiesModal titlePrefix={"Ready"} zipId={"dummy"} theme={theme} entityList={etlChanges.readyEntities} buttonText={etlChanges.readyEntities?.length} />
                                            </TableCell>
                                            <TableCell>
                                                <EntitiesModal titlePrefix={"RPA"} zipId={"dummy"} theme={theme} entityList={etlChanges.rpaEntities} buttonText={etlChanges.rpaEntities?.length} />
                                            </TableCell>
                                            <TableCell>
                                                {etlChanges.mostCommonChange ? etlChanges.mostCommonChange : ""}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            )}
        </React.Fragment>
    );
}
